import { render } from "./AddedToCart.vue?vue&type=template&id=83f27644&scoped=true"
import script from "./AddedToCart.vue?vue&type=script&lang=js"
export * from "./AddedToCart.vue?vue&type=script&lang=js"

import "./AddedToCart.vue?vue&type=style&index=0&id=83f27644&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f27644"]])

export default __exports__